import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class HomeService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    /**
     * GET /home — dashboard summary for the main page.
     * @param {string[]} [sections] restrict the computed summary sections
     */
    async getSummary(sections = []) {
        try {
            const raw = await withRetry(
                () => this.api.getSummary(sections),
                { maxRetries: 2 }
            );
            return {
                success: raw.success === true,
                data: raw.data,
                message: raw.message
            };
        } catch (error) {
            throw this._handleError(error, 'Ana sayfa verileri alınamadı');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) {
            throw error;
        }
        if (error.statusCode || error.status) {
            throw ApiError.fromResponse(error);
        }
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
